/* Steeping journey: numbered nodes on a winding path; tap a node and its step fades in.
   Shared by sections/steeping-journey.liquid and the Steeping block of sections/product-info-tabs.liquid.
   Roots are [data-steeping-journey]; init is idempotent (data-journey-ready). */
(function () {
  var FADE_MS = 180;

  function init(root) {
    if (!root || root.dataset.journeyReady) return;
    root.dataset.journeyReady = 'true';

    var nodes = Array.prototype.slice.call(root.querySelectorAll('[data-node]'));
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var stepLayers = Array.prototype.slice.call(root.querySelectorAll('[data-step-layer]'));
    var baseLayer = root.querySelector('[data-base-layer]');
    var panel = root.querySelector('[data-panel]');
    var journey = root.querySelector('.steeping-journey__journey');
    var svg = root.querySelector('[data-path]');
    var track = root.querySelector('[data-track]');
    var progress = root.querySelector('[data-progress]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animate = root.classList.contains('steeping-journey--animate') && !reduceMotion;
    var current = 0;
    var fadeTimer = null;
    var nodeDistances = [];

    /* ---- the winding path through the node centers ---- */
    function drawPath() {
      if (!svg || !journey || nodes.length < 2) return;
      var J = journey.getBoundingClientRect();
      if (!J.width) return;
      svg.setAttribute('viewBox', '0 0 ' + J.width + ' ' + J.height);
      svg.style.width = J.width + 'px';
      svg.style.height = J.height + 'px';

      var pts = nodes.map(function (n) {
        var r = n.getBoundingClientRect();
        return { x: r.left - J.left + r.width / 2, y: r.top - J.top + r.height / 2 };
      });

      /* smooth curve: cubic segments with horizontal tangents at each node */
      var d = 'M' + pts[0].x + ' ' + pts[0].y;
      for (var i = 1; i < pts.length; i++) {
        var a = pts[i - 1], b = pts[i];
        var cx = (a.x + b.x) / 2;
        d += ' C' + cx + ' ' + a.y + ' ' + cx + ' ' + b.y + ' ' + b.x + ' ' + b.y;
      }
      track.setAttribute('d', d);
      progress.setAttribute('d', d);

      /* distance along the path to each node, for the progress dash */
      var total = track.getTotalLength();
      nodeDistances = pts.map(function (p, i) {
        if (i === 0) return 0;
        if (i === pts.length - 1) return total;
        var best = 0, bestErr = Infinity;
        for (var s = 0; s <= total; s += 2) {
          var q = track.getPointAtLength(s);
          var err = Math.abs(q.x - p.x);
          if (err < bestErr) { bestErr = err; best = s; }
        }
        return best;
      });
      progress.style.strokeDasharray = total + ' ' + total;
      setProgress(current, true);
    }

    function setProgress(index, immediate) {
      if (!progress || !nodeDistances.length) return;
      var total = parseFloat(progress.style.strokeDasharray) || 0;
      if (immediate) progress.style.transition = 'none';
      progress.style.strokeDashoffset = total - (nodeDistances[index] || 0);
      if (immediate) { void progress.getBoundingClientRect(); progress.style.transition = ''; }
    }

    /* ---- selecting a step ---- */
    function showStep(index) {
      steps.forEach(function (s, i) {
        var on = i === index;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
    }

    function swapImage(index) {
      var match = null;
      stepLayers.forEach(function (layer) {
        if (parseInt(layer.dataset.stepLayer, 10) === index) match = layer;
      });
      stepLayers.forEach(function (layer) { layer.classList.toggle('is-showing', layer === match); });
      if (baseLayer) baseLayer.classList.toggle('is-showing', !match);
    }

    function select(index, opts) {
      opts = opts || {};
      if (index < 0 || index >= nodes.length) return;
      current = index;

      nodes.forEach(function (n, i) {
        var on = i === index;
        n.classList.toggle('is-active', on);
        n.classList.toggle('is-done', i < index);
        n.setAttribute('aria-selected', on ? 'true' : 'false');
        n.setAttribute('tabindex', on ? '0' : '-1');
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === nodes.length - 1;

      setProgress(index, !!opts.immediate);
      swapImage(index);

      if (fadeTimer) clearTimeout(fadeTimer);
      if (panel && animate && !opts.immediate) {
        panel.classList.add('is-fading');
        fadeTimer = setTimeout(function () {
          showStep(index);
          panel.classList.remove('is-fading');
        }, FADE_MS);
      } else {
        showStep(index);
      }
    }

    nodes.forEach(function (n, i) {
      n.addEventListener('click', function () { select(i); });
      n.addEventListener('keydown', function (e) {
        var t = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') t = Math.min(i + 1, nodes.length - 1);
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') t = Math.max(i - 1, 0);
        if (e.key === 'Home') t = 0;
        if (e.key === 'End') t = nodes.length - 1;
        if (t !== null) { e.preventDefault(); select(t); nodes[t].focus(); }
      });
    });
    if (prev) prev.addEventListener('click', function () { select(current - 1); });
    if (next) next.addEventListener('click', function () { select(current + 1); });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(drawPath, 120);
    });

    /* ---- reveal on scroll (same pattern as the sibling sections) ---- */
    var items = root.querySelectorAll('[data-reveal]');
    function arm() {
      items.forEach(function (el) { el.classList.add('is-revealed'); });
      root.classList.add('is-armed');
    }
    if (!animate || !('IntersectionObserver' in window)) {
      arm();
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { arm(); io.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.25 });
      io.observe(root);
    }

    /* Theme editor: selecting a step block shows it */
    document.addEventListener('shopify:block:select', function (e) {
      var step = e.target && e.target.closest ? e.target.closest('[data-step]') : null;
      if (step && root.contains(step)) select(parseInt(step.dataset.index, 10));
    });

    select(0, { immediate: true });
    drawPath();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(drawPath);
  }

  document.querySelectorAll('[data-steeping-journey]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-steeping-journey]');
    if (root) init(root);
  });
})();
